var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo';
// @ts-ignore
import { Head } from '@inertiajs/react';
export default function TermsOfService(_a) {
    var terms = _a.terms;
    return (_jsxs("div", __assign({ className: "font-sans text-gray-900 antialiased" }, { children: [_jsx(Head, { title: "Terms of service" }), _jsx("div", __assign({ className: "pt-4 bg-gray-100" }, { children: _jsxs("div", __assign({ className: "min-h-screen flex flex-col items-center pt-6 sm:pt-0" }, { children: [_jsx("div", { children: _jsx(JetAuthenticationCardLogo, {}) }), _jsx("div", { className: "w-full sm:max-w-2xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose", dangerouslySetInnerHTML: { __html: terms } })] })) }))] })));
}
